import DataCapturing from './data-capturing/DataCapturing';
import ConversionFactors from './conversion-factors/ConversionFactors';
import GeneralInformation from './general-information/GeneralInformation';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getUserCompanyData } from '../../../actions/carbonfootprint-rework/00-base/00-base-actions';

/**
* Reworked Dashboard Component, displayed as icons in the main dashboard accordion.
*
* @param {Object} props
* @param {string} props.variant string of "data-capturing", "conversion-factors" or "general-information"
* @returns {JSX.Element}
*/

export default function CarbonFootprinting({ variant }) {
    const dispatch = useDispatch()
    const company = useSelector((state) => (state.carbonFootprintBase.userCompanyData?.data?.company))
    const years = useSelector((state) => (state.carbonFootprintBase.userCompanyData?.data?.years))
    const groups = useSelector((state) => (state.carbonFootprintBase.userCompanyData?.data?.groups))
    const { companyId, groupId } = useSelector(state => state.auth.userData.carbonFootprintUser)

    useEffect(() => {
        if (companyId && groupId) {
            dispatch(getUserCompanyData(companyId, groupId))
        }
    }, [companyId, groupId])

    return (
        <>
            {variant === 'data-capturing' &&
                <DataCapturing variant={variant} company={company} years={years} groups={groups} />
            }
            {variant === 'conversion-factors' &&
                <ConversionFactors variant={variant} company={company} years={years} groups={groups} />
            }
            {variant === 'general-information' &&
                <GeneralInformation variant={variant} company={company} years={years} groups={groups} />
            }
        </>
    )
}



